import { radioGroupContext } from './chunk-4L7R5OAB.js';
import { $ariaBool } from './chunk-EVP5E6AO.js';
import { onPress } from './chunk-Z6A4GYXE.js';
import { menuContext } from './chunk-HSL7QSWM.js';
import { FocusVisibleController } from './chunk-LOFOQRT3.js';
import { __decorateClass } from './chunk-VPSTUDLO.js';
import { $$_next_template, $$_create_template } from 'maverick.js/dom';
import { signal, effect, hasProvidedContext, useContext, peek } from 'maverick.js';
import { defineElement, prop, Component } from 'maverick.js/element';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><div part="check"></div>`);
var Radio = class extends Component {
  constructor(instance) {
    super(instance);
    this.qa = signal(false);
    this.C = {
      Y: this.$props.value,
      bb: this.bb.bind(this),
      yb: null
    };
    new FocusVisibleController(instance);
  }
  get checked() {
    return this.qa();
  }
  onAttach() {
    effect(this.rc.bind(this));
    this._d();
    const isMenuItem = hasProvidedContext(menuContext);
    this.setAttributes({
      value: this.$props.value,
      role: isMenuItem ? "menuitemradio" : "radio",
      tabindex: isMenuItem ? -1 : 0,
      "aria-checked": $ariaBool(this.qa)
    });
  }
  onConnect(el) {
    this._d();
    onPress(el, this.G.bind(this));
  }
  onDisconnect() {
    const group = useContext(radioGroupContext);
    group.remove(this.C);
  }
  _d() {
    const group = useContext(radioGroupContext);
    group.add(this.C);
  }
  rc() {
    const { value } = this.$props, newValue = value();
    if (peek(this.qa)) {
      this.C.yb?.(newValue);
    }
  }
  G(event) {
    if (peek(this.qa))
      return;
    this.qa.set(true);
    this.dispatch("change", { trigger: event });
    this.C.yb?.(peek(this.$props.value), event);
  }
  bb(value, trigger) {
    if (peek(this.qa) === value)
      return;
    this.qa.set(value);
    this.dispatch("change", { trigger });
  }
  render() {
    return $$_next_template($$_templ);
  }
};
Radio.el = defineElement({
  tagName: "media-radio",
  props: { value: "" }
});
__decorateClass([
  prop
], Radio.prototype, "checked", 1);

export { Radio };
